import styled from 'styled-components';
import { Nav } from './_header_nav/mod';
import { AnalyticAction, AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { useService } from '@visiba/instantiation';
import { CallToAction } from './_header_call_to_action.component';
import { Logo } from '../logo.component';
import { useCurrentLocation } from '../../application/use_current_location';
import { Fragment } from 'react';
import { tokens } from '@cellula/react-theme-patient';
import { BreakPoints, useBreakpoint } from '@cellula/react';
import { NavigationMenu } from './_header_navigation_menu/mod';

interface Props {
	__TEMP__navigate?(url: string): void;
	__TEMP__onSignIn?: () => void;
	__TEMP__onSignOut?: () => void;
	__TEMP__changeLanguage?(langCode: string): void;
	/**
	 * @deprecated
	 */
	__TEMP__badgeCollector?: any;
}

const elements = {
	container: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 ${tokens.spacing.x2};
		height: 100%;
		width: 100%;
	`,
	left: styled.div`
		display: flex;
		align-items: center;
		height: 100%;
	`,
	right: styled.div`
		position: relative;
	`,
};

export function Header({ __TEMP__navigate, __TEMP__onSignIn, __TEMP__onSignOut, __TEMP__changeLanguage }: Props): JSX.Element {
	const analyticService = useService(AnalyticService);
	const breakpoints = useBreakpoint();
	const [unit, config] = useCurrentLocation();

	function trackEvent(action: AnalyticAction): void {
		analyticService.trackEvent(AnalyticCategories.TopNavigation, action);
	}

	return (
		<elements.container>
			{config != null ? (
				<Fragment>
					<elements.left>
						<Logo
							trackEvent={trackEvent}
							__TEMP__navigate={__TEMP__navigate}
							logoUrl={(config.theme.EmailLogoUrl as string) ?? (config.theme.LogoUrl as string) ?? ''}
							locationName={unit?.name ?? ''}
						/>
						<Nav trackEvent={trackEvent} __TEMP__navigate={__TEMP__navigate} />
					</elements.left>

					<elements.right>
						{breakpoints === BreakPoints.Small ? (
							<NavigationMenu __TEMP__onSignIn={__TEMP__onSignIn} __TEMP__onSignOut={__TEMP__onSignOut} />
						) : (
							<CallToAction
								__TEMP__onSignIn={__TEMP__onSignIn}
								__TEMP__onSignOut={__TEMP__onSignOut}
								__TEMP__navigate={__TEMP__navigate}
								__TEMP__changeLanguage={__TEMP__changeLanguage}
								trackEvent={trackEvent}
							/>
						)}
					</elements.right>
				</Fragment>
			) : null}
		</elements.container>
	);
}
